<template>
    <el-form :inline="true" class="demo-form-inline" :label-position="labelPosition" ref="myForm">
        <el-form-item label="Species">
            <el-select v-model="species" placeholder="Please select species" style="width:480px;">
            <el-option v-for="option in speciesOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="Tissue">
        <el-select v-model="tissue" placeholder="Please select tissue" style="width:480px;">
            <el-option v-for="option in tissueOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: flex-end;">
        <el-button class="analysis-button" size="small" type="primary" @click="handleSearch">search</el-button>
        <el-button class="analysis-button" size="small" type="primary" @click="resetForm">reset</el-button>
        <el-button class="analysis-button" size="small" type="primary" @click="exampleForm">example</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    data() {
        return {
        labelPosition: 'top',
        species: '',
        tissue: '',
        speciesOptions: [
                { label: 'human', value: 'human' },
                { label: 'mouse', value: 'mouse' }
        ],
        tissueOptions: [
            { label: 'ESC', value: 'ESC' },
            { label: 'PreME', value: 'PreME' },
            { label: 'ME', value: 'ME' },
            { label: 'hPGCLC', value: 'hPGCLC' },
            { label: 'hPGC', value: 'hPGC' },
            { label: 'DE', value: 'DE' },
        ],
        };
    },
    methods: {
        handleSearch() {
        if (!this.species || !this.tissue) {
            this.$message.error('Please select species and tissue.');
            return;
        }
        const params = { Species: this.species, Tissue: this.tissue };
        this.$router.push({ name: 'Enpanel', params }); // 调用 $router.push 方法跳转到 Sepanel 组件并传递参数
        },
        resetForm() {
        this.species = '';
        this.tissue = '';
        },
        exampleForm() {
            this.species = 'human';
            this.tissue = 'ESC';
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/teAnalysis/Enselect.vue